export default {
    title: "E-Mailvorlagen",
    name: "Name",
    type: "Typ",
    organisation: "Organisation",
    global: "Global",
    subject_de: "Betreff (Deutsch)",
    subject_en: "Betreff (Englisch)",
    content_de: "Inhalt (Deutsch)",
    content_en: "Inhalt (Englisch)",

    qf_ownOnly: "Nur eigene E-Mailvorlagen",
    qf_globalOnly: "Nur globale E-Mailvorlagen"
}